import React from 'react'
import SVGInline from "react-svg-inline"
import classnames from 'classnames';
import SidebarHeader from 'Components/sidebar-header';
import Panel from 'Components/panel';
import PanelBody from 'Components/panel/body';
import { __, sprintf } from 'StylistParent/i18n';
import Control from 'Components/control';
import CSSSelector from 'Components/css-selector';
import ResizeAndDragBox from 'react-rnd';

/* Import CSS */
import './index.scss'

class Sidebar extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			codeEditorMoved: false,
			previewAreaHeight: 0,
			initialSidebarPosX: 0,
			openPanel: true, // Used to hard-update/re-render controls.
		}

		// This binding is necessary to make `this` work in the callback
		this.handleHoverOn = this.handleHoverOn.bind( this )
		this.handleHoverOff = this.handleHoverOff.bind( this )
	}

	componentDidMount = () => {
		this.previewCoverEl = document.getElementById( "preview-cover" )
		this.previewAreaEl = document.getElementById( "stylist-preview-area" )
		const sidebarWidth = 280
		const panels = 88 // Top panels: 32px + 56px
		const previewAreaBottomPseudoPadding = 1000
		/**
		 * +1000 – is a hack needed to make floating sidebar movable to the bottom
		 * of the page when it has 100% of the heigh. 1000px is like a padding that
		 * expends draggable area.
		 */

		this.setState( {
			previewAreaHeight: this.previewAreaEl.offsetHeight - previewAreaBottomPseudoPadding - panels,
			initialSidebarPosX: this.previewAreaEl.offsetWidth - sidebarWidth,
		} )
	}

	componentDidUpdate = ( prevProps, prevState ) => {
		/**
		 * There is a very bad bug caused by <ResizeAndDragBox> component:
		 * it makes impossible to use any refs inside the componentDidMount().
		 * In our case we need to call CodeMirror by reference.
		 * To solve this problem we have to initiate CodeMirror editor
		 * outside the <Sidebar> component and then move it's code here
		 * once the user clicks on the "Code" tab inside sidebar.
		 */
		if ( this.props.sidebarTab === 'code' ) {
			/**
			 * this.state.codeEditorMoved prevents this code to run on every
			 * "Code" tab click, but only once in a life-time.
			 */
			if ( ! this.state.codeEditorMoved ) {
				// Move CodeMirror editor from the global dive into the "Code" tab.
				/* document.querySelector( '.stylist-sidebar--code' ).appendChild(
					document.querySelector( '.stylist-root .CodeMirror' )
				)

				this.setState( {
					codeEditorMoved: true
				} ) */
			}

			// On every Code tab click refresh editor view and focus on it.
			// window.Stylist.codeEditor.refresh() - May11
			// window.Stylist.codeEditor.focus() - May11
		}
	}

	handleHoverOn() {
		window.stlst_legacy.draw();

		window.Stylist.iDocJQ.find( window.stlst_elements ).stop().animate({
			opacity: 0
		}, 400);
	}

	handleHoverOff() {
		window.stlst_legacy.draw();

		window.Stylist.iDocJQ.find(window.stlst_elements).stop().not( ".stlst-selected-others-box").animate({
			opacity: 1
		}, 400);
	}

	onPanelChange = ( newPanelId ) => {
		this.props.onPanelChange( newPanelId )
	}

	isPanelOpen = ( panelId ) => {
		if ( panelId === this.props.sidebarPanel ) {
			return true /* eslint-disable no-else-return */
		} else {
			return false
		}
	}

	onSidebarTabChange = ( newId ) => {
		this.props.onSidebarTabChange( newId )
	}

	updateSidebarDimensions = () => {

	}

	render() {
		// const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
		// const currentStyle = window.stylistJsData.currentlyEditingTitle;

		const fontWeightOptions = [
			{
				value: '100',
				label: __( 'Thin' ) + ' 100',
			},
			{
				value: '200',
				label: __( 'Extra-Light' ) + ' 200',
			},
			{
				value: '300',
				label: __( 'Light' ) + ' 300',
			},
			{
				value: '400',
				label: __( 'Regular' ) + ' 400',
				default: true,
			},
			{
				value: '500',
				label: __( 'Semi-Bold' ) + ' 500',
			},
			{
				value: '600',
				label: __( 'Bold' ) + ' 600',
			},
			{
				value: '700',
				label: __( 'Extra-Bold' ) + ' 700',
			},
			{
				value: '800',
				label: __( 'Black' ) + ' 800',
			},

		];

		const fontStyleOptions = [
			{
				icon: 'editor-textcolor',
				title: __( 'Normal' ),
				value: 'normal',
			},
			{
				icon: 'editor-italic',
				title: __( 'Italic' ),
				value: 'italic',
			},
		];

		const textAlignOptions = [
			{
				icon: 'editor-alignleft',
				title: __( 'Align left' ),
				value: 'left',
			},
			{
				icon: 'editor-aligncenter',
				title: __( 'Align center' ),
				value: 'center',
			},
			{
				icon: 'editor-alignright',
				title: __( 'Align right' ),
				value: 'right',
			},
		];

		const textTransformOptions = [
			{
				icon: 'editor-uppercase',
				title: __( 'Uppercase' ),
				value: 'uppercase',
			},
			{
				icon: 'editor-lowercase',
				title: __( 'Lowercase' ),
				value: 'lowercase',
			},
			{
				icon: 'editor-capitalize',
				title: __( 'Capitalize' ),
				value: 'capitalize',
			},
		];

		const wordWrapOptions = [
			{
				icon: 'editor-uppercase',
				title: __( 'Normal' ),
				value: 'normal',
			},
			{
				icon: 'editor-break',
				title: __( 'Break Word' ),
				value: 'break-word',
			},
		];

		const textDecorationOptions = [
			{
				icon: 'editor-underline',
				title: __( 'Underline' ),
				value: 'underline',
			},
			{
				icon: 'editor-overline',
				title: __( 'Overline' ),
				value: 'overline',
			},
			{
				icon: 'editor-strikethrough',
				title: __( 'Through' ),
				value: 'line-through',
			},
		];

		const borderStyleOptions = [
			{
				icon: 'border-solid',
				title: __( 'Solid' ),
				value: 'solid',
			},
			{
				icon: 'border-dotted',
				title: __( 'Dotted' ),
				value: 'dotted',
			},
			{
				icon: 'border-dashed',
				title: __( 'Dashed' ),
				value: 'dashed',
			},
			{
				icon: 'no-alt-2',
				title: __( 'Hidden' ),
				value: 'hidden',
			},
		];

		const simpleAdvancedControlOptions = [
			{
				icon: 'admin-customizer',
				title: __( 'Simple' ),
				value: 'simple',
			},
			{
				icon: 'admin-settings',
				title: __( 'Advanced' ),
				value: 'advanced',
			},
		];

		return (
			<ResizeAndDragBox
				ref={ c => {
					this.rnd = c;
				} }
				className="stylist-sidebar-wrapper"
				dragHandleClassName=".components-panel__header"
				dragAxis="both"
				bounds="#stylist-preview-area"
				z="60000"
				minWidth={280}
				default={ {
					x: this.state.initialSidebarPosX,
					y: 0,
					width: 280, // width: "280px"
					height: this.state.previewAreaHeight,
				} }

				enableResizing={ {
					top: false,
					right: true,
					bottom: false,
					left: true,
					topRight: true,
					bottomRight: false,
					bottomLeft: true,
					topLeft: false
				} }

				onResizeStart={ () => {
					this.previewCoverEl.classList.add( 'active' )
				} }

				onResizeStop={ () => {
					this.previewCoverEl.classList.remove( 'active' )
				} }

				onDragStart={ ( e, ui ) => {
					this.previewCoverEl.classList.add( 'active' )
				} }

				onDragStop={ ( e, ui ) => {
					this.rnd.updateSize( {
						width: this.rnd.resizable.state.width,
						height: this.state.previewAreaHeight - ui.y
					} )
					this.previewCoverEl.classList.remove( 'active' )
				} }
			>
				<div
					id="stylist-sidebar"
					className="stylist-sidebar"
					onMouseEnter={this.handleHoverOn}
					onMouseLeave={this.handleHoverOff}
					ref={ el => this.el = el }
				>
					<SidebarHeader
						sidebarTab={this.props.sidebarTab}
						onSidebarTabChange={this.onSidebarTabChange} />
					{ 'styling' === this.props.sidebarTab &&
						this.props.cssCacheReady &&
						! this.props.inspectorActive &&
						<div>
							<Panel header="Header Label">
								<div className="stylist-sidebar-content">
									<PanelBody
										className="editor-block-inspector__content"
										title={ __( 'Text' ) }
										initialOpen={ false }
										panelId={'text'}
										onPanelChange={ () => this.onPanelChange( 'text' ) }
										currentSidebarPanel={ this.props.currentSidebarPanel } >
										<Control
											type="slider"
											name={ __( 'Font Size' ) }
											cssProperty="font-size"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														px: {
															step: 1,
															max: 100,
															min: 6,
														},
														em: {
															step: .01,
															max: 10,
															min: 0,
														},
														'%': {
															step: 1,
															max: 500,
															min: 10,
														},
													}
												}
											} />
										<Control
											type="slider"
											name={ __( 'Font Weight' ) }
											cssProperty="font-weight"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														'': {
															step: 100,
															max: 800,
															min: 100,
														},
													},
													marks: {
														'': {
															100: 'Thin', // Thin
															200: '',
															300: '',
															400: 'Regular', // Regular
															500: '',
															600: 'Bold', // Bold
															700: '',
															800: 'Black', // Black
														},
													},
													showInput: false,
												}
											} />
										<Control
											type="color"
											name={ __( 'Color' ) }
											cssProperty="color"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }
											panelId={'text/advanced'}
											onPanelChange={ () => this.onPanelChange( 'text/advanced' ) }
											currentSidebarPanel={ this.props.currentSidebarPanel }>

											<Control
												type="font"
												name={__( 'Font Family' )}
												cssProperty="font-family"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={fontWeightOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="radio"
												name={__( 'Text Align' )}
												cssProperty="text-align"
												cssDefault="start"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={textAlignOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="slider"
												name={ __( 'Line Height' ) }
												cssProperty="line-height"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: 6,
															},
															em: {
																step: .01,
																max: 14,
																min: 0,
															},
															'': {
																step: .05,
																max: 14,
																min: 0,
															},
														}
													}
												} />

											<Control
												type="radio"
												name={ __( 'Font Style' ) }
												cssProperty="font-style"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={fontStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="radio"
												name={__( 'Text Transform' )}
												cssProperty="text-transform"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={textTransformOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="slider"
												name={ __( 'Letter Spacing' ) }
												cssProperty="letter-spacing"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: .25,
																max: 25,
																min: -25,
															},
															em: {
																step: .001,
																max: 2,
																min: -2,
															}
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Word Spacing' ) }
												cssProperty="word-spacing"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: .5,
																max: 25,
																min: -25,
															},
															em: {
																step: .001,
																max: 2,
																min: -2,
															}
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Text Indent' ) }
												cssProperty="text-indent"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 100,
																min: -100,
															},
															em: {
																step: .001,
																max: 4,
																min: -4,
															},
															'%': {
																step: 1,
																max: 50,
																min: -50,
															},
														},
														marks: {
															px: {
																100: '100',
																50: '50',
																0: '0',
																'-50': '-50',
																'-100': '-100',
															},
															em: {
																0: '0',
															},
															'%': {
																0: '0',
															},
														},
													}
												} />
											<Control
												type="radio"
												name={ __( 'Text Decoration' ) }
												cssProperty="text-decoration"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={textDecorationOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="radio"
												name={ __( 'Word Wrap' ) }
												cssProperty="word-wrap"
												cssDefault="normal"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={wordWrapOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Background' )}
										initialOpen={false}
										panelId={'background'}
										onPanelChange={ () => this.onPanelChange( 'background' ) }
										currentSidebarPanel={ this.props.currentSidebarPanel }>

										<Control
											type="color"
											name={ __( 'Color' ) }
											cssProperty="background-color"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<Control
											type="upload"
											name={ __( 'Image' ) }
											cssProperty="background-image"
											cssDefault="none"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											// values={fontStyleOptions}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<Control
											type="radio"
											name={ __( 'Repeat' ) }
											cssProperty="background-repeat"
											cssDefault="repeat"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											values={[
												{
													icon: 'grid',
													title: __( 'Both Ways' ),
													value: 'repeat',
												},
												{
													icon: 'ellipsis',
													title: __( 'Horizontally' ),
													value: 'repeat-x',
												},
												{
													icon: 'ellipsis-vertical',
													title: __( 'Vertically' ),
													value: 'repeat-y',
												},
												{
													icon: 'no-alt-2',
													title: __( 'None' ),
													value: 'no-repeat',
												},
											]}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }
											panelId={'background/advanced'}
											onPanelChange={ () => this.onPanelChange( 'background/advanced' ) }
											currentSidebarPanel={ this.props.currentSidebarPanel }>

											<Control
												type="radio"
												name={ __( 'Fixed' ) }
												cssProperty="background-attachment"
												cssDefault="scroll"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={[
													{
														icon: 'admin-post',
														title: __( 'Fixed' ),
														value: 'fixed',
													},
													{
														icon: 'no-alt-2',
														title: __( 'None' ),
														value: 'scroll',
													},
												]}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="radio"
												name={ __( 'Size' ) }
												cssProperty="background-size"
												cssDefault="auto"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={[
													{
														icon: 'editor-expand',
														title: __( 'Cover' ),
														value: 'cover',
													},
													{
														icon: 'editor-contract',
														title: __( 'Contain' ),
														value: 'contain',
													},
												]}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="slider"
												name={ __( 'Horizontal Position' ) }
												cssProperty="background-position-x"
												cssDefault="0"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 1000,
																min: 0,
															},
															'%': {
																step: .05,
																max: 100,
																min: 0,
															},
															wh: {
																step: .05,
																max: 100,
																min: 0,
															},
															em: {
																step: .01,
																max: 70,
																min: 0,
															},
														},
														marks: {
															px: {},
															vw: {
																0: '0%',
																50: '50%',
																100: '100%'
															},
															em: {},
															'%': {
																0: 'Left',
																50: 'Center',
																100: 'Right'
															}
														}
													}
												} />

											<Control
												type="slider"
												name={ __( 'Vertical Position' ) }
												cssProperty="background-position-y"
												cssDefault="0"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 1000,
																min: 0,
															},
															'%': {
																step: .05,
																max: 100,
																min: 0,
															},
															vh: {
																step: .05,
																max: 100,
																min: 0,
															},
															em: {
																step: .01,
																max: 70,
																min: 0,
															},
														},
														marks: {
															px: {},
															vh: {
																0: '0%',
																50: '50%',
																100: '100%'
															},
															em: {},
															'%': {
																0: 'Top',
																50: 'Center',
																100: 'Bottom'
															}
														}
													}
												} />
										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Margin' )}
										initialOpen={false}
										panelId={'margin'}
										onPanelChange={ () => this.onPanelChange( 'margin' ) }
										currentSidebarPanel={ this.props.currentSidebarPanel }>
										<Control
											type="slider"
											name={ __( 'All Sides' ) }
											cssProperty="margin"
											cssDefault="initial"
											notice=""
											onPanelChange={ this.onPanelChange }
											currentSidebarPanel={ this.props.currentSidebarPanel }
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														px: {
															step: 1,
															max: 200,
															min: -200,
														},
														em: {
															step: .01,
															max: 14,
															min: -14,
														},
														'%': {
															step: .05,
															max: 10,
															min: -10,
														},
													}
												}
											} />
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }
											panelId={'margin/advanced'}
											onPanelChange={ () => this.onPanelChange( 'margin/advanced' ) }
											currentSidebarPanel={ this.props.currentSidebarPanel }>
											<Control
												type="slider"
												name={ __( 'Top' ) }
												cssProperty="margin-top"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: -200,
															},
															em: {
																step: .01,
																max: 14,
																min: -14,
															},
															'%': {
																step: .05,
																max: 10,
																min: -10,
															},
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Right' ) }
												cssProperty="margin-right"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: -200,
															},
															em: {
																step: .01,
																max: 14,
																min: -14,
															},
															'%': {
																step: .05,
																max: 10,
																min: -10,
															},
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Bottom' ) }
												cssProperty="margin-bottom"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: -200,
															},
															em: {
																step: .01,
																max: 14,
																min: -14,
															},
															'%': {
																step: .05,
																max: 10,
																min: -10,
															},
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Left' ) }
												cssProperty="margin-left"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: -200,
															},
															em: {
																step: .01,
																max: 14,
																min: -14,
															},
															'%': {
																step: .05,
																max: 10,
																min: -10,
															},
														}
													}
												} />
										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Padding' )}
										initialOpen={false}
										panelId={'padding'}
										onPanelChange={ () => this.onPanelChange( 'padding' ) }
										currentSidebarPanel={ this.props.currentSidebarPanel }>
										<Control
											type="slider"
											name={ __( 'All Sides' ) }
											cssProperty="padding"
											cssDefault="initial"
											notice=""
											onPanelChange={ this.onPanelChange }
											currentSidebarPanel={ this.props.currentSidebarPanel }
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														px: {
															step: 1,
															max: 200,
															min: 0,
														},
														em: {
															step: .01,
															max: 14,
															min: 0,
														},
														'%': {
															step: .05,
															max: 10,
															min: 0,
														},
													}
												}
											} />
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }
											panelId={'padding/advanced'}
											onPanelChange={ () => this.onPanelChange( 'padding/advanced' ) }
											currentSidebarPanel={ this.props.currentSidebarPanel }>
											<Control
												type="slider"
												name={ __( 'Top' ) }
												cssProperty="padding-top"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: 0,
															},
															em: {
																step: .01,
																max: 14,
																min: 0,
															},
															'%': {
																step: .05,
																max: 10,
																min: 0,
															},
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Right' ) }
												cssProperty="padding-right"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: 0,
															},
															em: {
																step: .01,
																max: 14,
																min: 0,
															},
															'%': {
																step: .05,
																max: 10,
																min: 0,
															},
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Bottom' ) }
												cssProperty="padding-bottom"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: 0,
															},
															em: {
																step: .01,
																max: 14,
																min: 0,
															},
															'%': {
																step: .05,
																max: 10,
																min: 0,
															},
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Left' ) }
												cssProperty="padding-left"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: 0,
															},
															em: {
																step: .01,
																max: 14,
																min: 0,
															},
															'%': {
																step: .05,
																max: 10,
																min: 0,
															},
														}
													}
												} />
										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Rounded Corners' )}
										initialOpen={false}
										panelId={'border-radius'}
										onPanelChange={ () => this.onPanelChange( 'border-radius' ) }
										currentSidebarPanel={ this.props.currentSidebarPanel }>
										<Control
											type="slider"
											name={ __( 'All Sides' ) }
											cssProperty="border-radius"
											cssDefault="initial"
											notice=""
											onPanelChange={ this.onPanelChange }
											currentSidebarPanel={ this.props.currentSidebarPanel }
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														px: {
															step: 1,
															max: 100,
															min: 0,
														}
													}
												}
											} />
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }
											panelId={'border-radius/advanced'}
											onPanelChange={ () => this.onPanelChange( 'border-radius/advanced' ) }
											currentSidebarPanel={ this.props.currentSidebarPanel }>
											<Control
												type="slider"
												name={ __( 'Top-Left' ) }
												cssProperty="border-top-left-radius"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 100,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Top-Right' ) }
												cssProperty="border-top-right-radius"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 100,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Bottom-Right' ) }
												cssProperty="border-bottom-right-radius"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 100,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Bottom-Left' ) }
												cssProperty="border-bottom-left-radius"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 100,
																min: 0,
															}
														}
													}
												} />
										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Border' )}
										initialOpen={false}
										panelId={'border'}
										onPanelChange={ () => this.onPanelChange( 'border' ) }
										currentSidebarPanel={ this.props.currentSidebarPanel }>

										<Control
											type="slider"
											name={ __( 'Width' ) }
											cssProperty="border-width"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														px: {
															step: 1,
															max: 50,
															min: 0,
														},
														em: {
															step: .01,
															max: 5,
															min: 0,
														}
													}
												}
											} />
										<Control
											type="radio"
											name={ __( 'Style' ) }
											cssProperty="border-style"
											cssDefault="none"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											values={borderStyleOptions}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />
										<Control
											type="color"
											name={ __( 'Color' ) }
											cssProperty="border-color"
											cssDefault="transparent"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={__( 'Top' )}
											initialOpen={false}
											panelId={'border/top'}
											onPanelChange={ () => this.onPanelChange( 'border/top' ) }
											currentSidebarPanel={ this.props.currentSidebarPanel }>

											<Control
												type="slider"
												name={ __( 'Width' ) }
												cssProperty="border-top-width"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 50,
																min: 0,
															},
															em: {
																step: .01,
																max: 5,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="radio"
												name={ __( 'Style' ) }
												cssProperty="border-top-style"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={borderStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="color"
												name={ __( 'Color' ) }
												cssProperty="border-top-color"
												cssDefault="transparent"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
										</PanelBody>
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={__( 'Right' )}
											initialOpen={false}
											panelId={'border/right'}
											onPanelChange={ () => this.onPanelChange( 'border/right' ) }
											currentSidebarPanel={ this.props.currentSidebarPanel }>

											<Control
												type="slider"
												name={ __( 'Width' ) }
												cssProperty="border-right-width"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 50,
																min: 0,
															},
															em: {
																step: .01,
																max: 5,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="radio"
												name={ __( 'Style' ) }
												cssProperty="border-right-style"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={borderStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="color"
												name={ __( 'Color' ) }
												cssProperty="border-right-color"
												cssDefault="transparent"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
										</PanelBody>
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={__( 'Bottom' )}
											initialOpen={false}
											panelId={'border/bottom'}
											onPanelChange={ () => this.onPanelChange( 'border/bottom' ) }
											currentSidebarPanel={ this.props.currentSidebarPanel }>

											<Control
												type="slider"
												name={ __( 'Width' ) }
												cssProperty="border-bottom-width"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 50,
																min: 0,
															},
															em: {
																step: .01,
																max: 5,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="radio"
												name={ __( 'Style' ) }
												cssProperty="border-bottom-style"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={borderStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="color"
												name={ __( 'Color' ) }
												cssProperty="border-bottom-color"
												cssDefault="transparent"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
										</PanelBody>
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={__( 'Left' )}
											initialOpen={false}
											panelId={'border/left'}
											onPanelChange={ () => this.onPanelChange( 'border/left' ) }
											currentSidebarPanel={ this.props.currentSidebarPanel }>

											<Control
												type="slider"
												name={ __( 'Width' ) }
												cssProperty="border-left-width"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 50,
																min: 0,
															},
															em: {
																step: .01,
																max: 5,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="radio"
												name={ __( 'Style' ) }
												cssProperty="border-left-style"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={borderStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="color"
												name={ __( 'Color' ) }
												cssProperty="border-left-color"
												cssDefault="transparent"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
										</PanelBody>

									</PanelBody>
								</div>
							</Panel>
						</div>
					}
					{ this.props.sidebarTab !== 'code' && this.props.sidebarTab !== 'pro' && this.props.sidebarTab !== 'promo' && this.props.inspectorActive &&
						<div className="stylist-sidebar--active-inspector">
							{/* https://www.npmjs.com/package/react-svg-inline */}
							<SVGInline svg={ '<svg xmlns="http://www.w3.org/2000/svg" width="246" height="167" viewBox="0 0 246 167" version="1.1"><defs><linearGradient x1="0" y1="100" x2="93.3" y2="5.6" id="linearGradient-1"><stop stop-color="#9866FE" offset="0"/><stop stop-color="#009FD2" offset="71"/><stop stop-color="#02B9F3" offset="100"/></linearGradient><path d="M14.4 41.7L225.4 2.7C234.6 1 243.5 7.1 245.2 16.3 245.4 17.4 245.5 18.4 245.5 19.4L245.5 112.9C245.5 121.1 239.7 128.1 231.6 129.6L20.6 168.6C11.4 170.3 2.5 164.2 0.8 155 0.6 153.9 0.5 152.9 0.5 151.9L0.5 58.4C0.5 50.2 6.3 43.2 14.4 41.7Z" id="path-2"/><linearGradient x1="88.2" y1="56.6" x2="10.5" y2="80.6" id="linearGradient-4"><stop stop-color="#7A71F6" offset="0"/><stop stop-color="#00C2FF" offset="100"/></linearGradient><linearGradient x1="15.5" y1="77.3" x2="84" y2="-9" id="linearGradient-5"><stop stop-color="#AC11FE" offset="0"/><stop stop-color="#00C2FF" offset="100"/></linearGradient><rect id="path-6" x="0" y="0" width="38" height="74" rx="5"/></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="illustration" transform="translate(0.000000, -2.000000)"><g id="BG-shape"><mask id="mask-3" fill="white"><use xlink:href="#path-2"/></mask><use id="Mask" fill="url(#linearGradient-1)" xlink:href="#path-2"/><path d="M-43.3-24.2C-18.1-65.3 24.9-47.2 60.3-24.2 95.7-1.2 152.5 5.3 205.7-23.8 259-53 295.1 13.7 281.3 50.4 267.5 87.1 227.3 119.6 107.1 119.6 -13.2 119.6-68.5 16.9-43.3-24.2Z" id="Path-2" fill="url(#linearGradient-4)" opacity="0.2" mask="url(#mask-3)"/><path d="M274.8 139.4C256.2 200.9 181.4 174 148.9 159.4 116.4 144.7 115 181.1 58.1 200.9 1.2 220.7-72.9 194.7-42.9 159.4 -12.8 124 44.9 82.1 125.9 59.9 207 37.7 293.4 77.8 274.8 139.4Z" id="Path-2-Copy" fill="url(#linearGradient-5)" opacity="0.2" mask="url(#mask-3)"/></g><g id="MacBook" transform="translate(39.000000, 39.000000)"><rect id="Rectangle-2" fill="#24282D" x="15" y="0" width="146" height="100" rx="5"/><rect id="Rectangle-2-Copy-3" fill="#18B4FF" x="22" y="7" width="132" height="81" rx="1"/><g id="Group-2" transform="translate(0.000000, 93.000000)"><rect id="Rectangle-2-Copy" fill="#666B6F" x="0" y="0" width="176" height="7" rx="3"/><path d="M70 0L107 0C107 1.7 105.7 3 104 3L73 3C71.3 3 70 1.7 70 0Z" id="Combined-Shape" fill="#8A8F93"/></g><g id="Screen---desktop" transform="translate(35.000000, 17.000000)"><rect id="Browser" fill="#FFFFFF" x="0" y="0" width="108" height="71" rx="2"/><g id="Content---descktop" transform="translate(9.000000, 29.000000)"><g id="Illustration"><rect id="Rectangle-4-Copy" fill="#96D327" x="0" y="0" width="38" height="32" rx="2"/><path d="M38 7.7C34 10.6 28 12.5 20.2 13.3 12.2 14.2 5.5 16.5 0 20.1L0 2C0 0.9 0.9 0 2 0L36 0C37.1 0 38 0.9 38 2L38 7.7Z" id="Combined-Shape" fill="#A4EB21"/></g><g id="Text" transform="translate(47.000000, 0.000000)"><rect id="Rectangle-5-Copy-4" fill="#DADFE2" x="0" y="10" width="37" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-5" fill="#DADFE2" x="0" y="10" width="37" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-9" fill="#BFC9CE" x="0" y="0" width="32" height="5" rx="2.5"/><rect id="Rectangle-5-Copy-6" fill="#DADFE2" x="0" y="16" width="37" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-7" fill="#DADFE2" x="0" y="22" width="37" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-8" fill="#DADFE2" x="0" y="28" width="27" height="3" rx="1.5"/></g></g><g id="Header---descktop" transform="translate(1.000000, 7.000000)"><rect id="Rectangle-5" fill="#DADFE2" x="35" y="1" width="17" height="3" rx="1.5"/><path d="M0 12L107 12" id="Line" stroke="#DADFE2" opacity="0.4" stroke-linecap="square"/><rect id="Rectangle-5-Copy-3" fill="#0C93EB" x="9" y="0" width="10" height="6" rx="3"/><rect id="Rectangle-5-Copy" fill="#DADFE2" x="57" y="1" width="17" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-2" fill="#DADFE2" x="79" y="1" width="17" height="3" rx="1.5"/></g></g></g><g id="iPhone" transform="translate(32.000000, 70.000000)"><g id="Rectangle-2-Copy-4"><use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-6"/><rect stroke="#24282D" stroke-width="2" x="1" y="1" width="36" height="72" rx="5"/></g><rect id="Rectangle-3" fill="#24282D" x="9" y="0" width="19" height="4" rx="2"/><g id="iPhone-Screen" transform="translate(3.000000, 9.000000)"><g id="Content---mobile" transform="translate(4.000000, 15.000000)"><g id="Illustration---mobile"><rect id="Rectangle-4-Copy-2" fill="#96D327" x="0" y="0" width="24" height="20" rx="2"/><path d="M24 5.2C21.5 7.1 17.7 8.4 12.8 8.9 7.7 9.5 3.5 10.9 0 13.3L0 2C0 0.9 0.9 0 2 0L22 0C23.1 0 24 0.9 24 2L24 5.2Z" id="Combined-Shape-Copy" fill="#A4EB21"/></g><g id="Text---mobile" transform="translate(0.000000, 25.000000)"><rect id="Rectangle-5-Copy-4" fill="#DADFE2" x="0" y="6.5" width="24" height="1.9" rx="1"/><rect id="Rectangle-5-Copy-9" fill="#BFC9CE" x="0" y="0" width="21" height="3.2" rx="1.6"/><rect id="Rectangle-5-Copy-7" fill="#DADFE2" x="0" y="10.3" width="24" height="1.9" rx="1"/><rect id="Rectangle-5-Copy-8" fill="#DADFE2" x="0" y="14.1" width="18" height="1.9" rx="1"/></g></g><g id="Header---mobile"><rect id="Rectangle-5-Copy-11" fill="#DADFE2" x="16" y="1" width="13" height="3" rx="1.5"/><path d="M0 10L32 10" id="Line-Copy" stroke="#DADFE2" opacity="0.4" stroke-linecap="square"/><rect id="Rectangle-5-Copy-10" fill="#0C93EB" x="3" y="0" width="9" height="5" rx="2.5"/></g></g></g><g id="Stars" transform="translate(15.000000, 3.000000)" fill="#FFFFFF" opacity="0.7"><path d="M62.4 16.2L62.4 16.2C61.4 16.6 60.3 16.1 59.9 15.2 59.8 14.7 59.8 14.2 59.9 13.7L59.9 13.7C61 11.1 61 8.1 59.9 5.4L59.9 5.4C59.6 4.4 60 3.3 61 2.9 61.5 2.8 62 2.8 62.4 2.9L62.4 2.9C65.1 4 68.1 4 70.7 2.9L70.7 2.9C71.7 2.6 72.8 3 73.2 4 73.4 4.5 73.4 5 73.2 5.4L73.2 5.4C72.1 8.1 72.1 11.1 73.2 13.7L73.2 13.7C73.6 14.7 73.1 15.8 72.2 16.2 71.7 16.4 71.2 16.4 70.7 16.2L70.7 16.2C68.1 15.1 65.1 15.1 62.4 16.2Z" id="Star" transform="translate(66.579533, 9.579533) rotate(45.000000) translate(-66.579533, -9.579533) "/><path d="M205.4 113.2L205.4 113.2C204.4 113.6 203.3 113.1 202.9 112.2 202.8 111.7 202.8 111.2 202.9 110.7L202.9 110.7C204 108.1 204 105.1 202.9 102.4L202.9 102.4C202.6 101.4 203 100.3 204 99.9 204.5 99.8 205 99.8 205.4 99.9L205.4 99.9C208.1 101 211.1 101 213.7 99.9L213.7 99.9C214.7 99.6 215.8 100 216.2 101 216.4 101.5 216.4 102 216.2 102.4L216.2 102.4C215.1 105.1 215.1 108.1 216.2 110.7L216.2 110.7C216.6 111.7 216.1 112.8 215.2 113.2 214.7 113.4 214.2 113.4 213.7 113.2L213.7 113.2C211.1 112.1 208.1 112.1 205.4 113.2Z" id="Star-Copy" transform="translate(209.579533, 106.579533) rotate(45.000000) translate(-209.579533, -106.579533) "/><path d="M3.8 42.4L3.8 42.4C3.1 42.7 2.4 42.4 2.1 41.7 1.9 41.4 1.9 41 2.1 40.7L2.1 40.7C2.8 38.8 2.8 36.7 2.1 34.8L2.1 34.8C1.8 34.1 2.1 33.4 2.8 33.1 3.1 32.9 3.5 32.9 3.8 33.1L3.8 33.1C5.7 33.8 7.8 33.8 9.7 33.1L9.7 33.1C10.4 32.8 11.2 33.1 11.4 33.8 11.6 34.1 11.6 34.5 11.4 34.8L11.4 34.8C10.7 36.7 10.7 38.8 11.4 40.7L11.4 40.7C11.7 41.4 11.4 42.2 10.7 42.4 10.4 42.6 10 42.6 9.7 42.4L9.7 42.4C7.8 41.7 5.7 41.7 3.8 42.4Z" id="Star-Copy-3" transform="translate(6.752870, 37.752870) rotate(45.000000) translate(-6.752870, -37.752870) "/><path d="M195.8 44.4L195.8 44.4C195.1 44.7 194.4 44.4 194.1 43.7 193.9 43.4 193.9 43 194.1 42.7L194.1 42.7C194.8 40.8 194.8 38.7 194.1 36.8L194.1 36.8C193.8 36.1 194.1 35.4 194.8 35.1 195.1 34.9 195.5 34.9 195.8 35.1L195.8 35.1C197.7 35.8 199.8 35.8 201.7 35.1L201.7 35.1C202.4 34.8 203.2 35.1 203.4 35.8 203.6 36.1 203.6 36.5 203.4 36.8L203.4 36.8C202.7 38.7 202.7 40.8 203.4 42.7L203.4 42.7C203.7 43.4 203.4 44.2 202.7 44.4 202.4 44.6 202 44.6 201.7 44.4L201.7 44.4C199.8 43.7 197.7 43.7 195.8 44.4Z" id="Star-Copy-2" transform="translate(198.752870, 39.752870) rotate(45.000000) translate(-198.752870, -39.752870) "/><path d="M167.4 151.5L167.4 151.5C166.9 151.7 166.3 151.4 166.1 150.9 166 150.6 166 150.3 166.1 150.1L166.1 150.1C166.7 148.6 166.7 146.9 166.1 145.4L166.1 145.4C165.8 144.9 166.1 144.3 166.6 144.1 166.9 144 167.2 144 167.4 144.1L167.4 144.1C168.9 144.7 170.6 144.7 172.1 144.1L172.1 144.1C172.6 143.8 173.2 144.1 173.5 144.6 173.6 144.9 173.6 145.2 173.5 145.4L173.5 145.4C172.8 146.9 172.8 148.6 173.5 150.1L173.5 150.1C173.7 150.6 173.4 151.2 172.9 151.5 172.6 151.6 172.3 151.6 172.1 151.5L172.1 151.5C170.6 150.8 168.9 150.8 167.4 151.5Z" id="Star-Copy-4" transform="translate(169.752870, 147.752870) rotate(45.000000) translate(-169.752870, -147.752870) "/></g></g></g></svg>' } />
							<h2>{ __( 'Easily style any page element' ) }</h2>
							{/* <ol>
								<li>{ __("Click on any page element") }</li>
								<li>{ __("Edit it's styling in this panel") }</li>
								<li>{ __("Check responsive presentation") }</li>
								<li>{ __("Save to apply changes") }</li>
							</ol> */}
						</div>
					}
					<div className={classnames( 'stylist-sidebar--code', { active: this.props.sidebarTab === 'code' } )} id="stylist-sidebar--code">
						<p className="stylist-sidebar--code-notice"><span className="dashicons dashicons-editor-code"></span> { __( 'CSS code only' ) }</p>
						<div className="stylist-sidebar--code-editor" id="stylist-sidebar--code-editor"></div>
						{/* CodeMirror editor is being moved here on tab activation. */}
					</div>
					{ this.props.sidebarTab === 'pro' &&
						<div className={classnames( 'stylist-sidebar--pro', { active: this.props.sidebarTab === 'pro' } )} id="stylist-sidebar--pro">
							<div>
								{/* https://www.npmjs.com/package/react-svg-inline */}
								<SVGInline svg={ '<svg width="246" height="167"  viewBox="0 0 246 167" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="0%" y1="100%" x2="93.3%" y2="5.6%" id="b"><stop stop-color="#9866FE" offset="0%"/><stop stop-color="#009FD2" offset="71%"/><stop stop-color="#02B9F3" offset="100%"/></linearGradient><path d="M14.4 41.7l211-39a17 17 0 0 1 20.1 16.7V113a17 17 0 0 1-14 16.7l-211 39a17 17 0 0 1-20-16.7V58.4a17 17 0 0 1 14-16.7z" id="a"/><linearGradient x1="88.2%" y1="56.6%" x2="10.5%" y2="80.6%" id="c"><stop stop-color="#7A71F6" offset="0%"/><stop stop-color="#00C2FF" offset="100%"/></linearGradient><linearGradient x1="15.5%" y1="77.3%" x2="84%" y2="-9%" id="e"><stop stop-color="#AC11FE" offset="0%"/><stop stop-color="#00C2FF" offset="100%"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><g transform="translate(0 -2)"><mask id="d" fill="#fff"><use xlink:href="#a"/></mask><use fill="url(#b)" xlink:href="#a"/><path d="M-43.3-24.2c25.2-41 68.2-23 103.6 0 35.4 23 92.2 29.5 145.4.4C259-53 295.1 13.7 281.3 50.4c-13.8 36.7-54 69.2-174.2 69.2-120.3 0-175.6-102.7-150.4-143.8z" fill="url(#c)" opacity=".2" mask="url(#d)"/><path d="M274.8 139.4c-18.6 61.5-93.4 34.6-125.9 20-32.5-14.7-33.9 21.7-90.8 41.5-57 19.8-131-6.2-101-41.5C-12.8 124 45 82 126 59.9c81-22.2 167.5 17.9 148.9 79.5z" fill="url(#e)" opacity=".2" mask="url(#d)"/></g><g fill="#FFF" opacity=".7"><path d="M81 26a1.7 1.7 0 0 1 0-3.1c2.3-1 4.2-2.9 5.2-5.2a1.7 1.7 0 0 1 3 0c1 2.3 2.9 4.2 5.2 5.2a1.7 1.7 0 0 1 0 3 9.7 9.7 0 0 0-5.1 5.2 1.7 1.7 0 0 1-3.1 0 9.7 9.7 0 0 0-5.2-5.2zM207.1 111a1.7 1.7 0 0 1 0-3.1c2.3-1 4.2-2.8 5.2-5.2a1.7 1.7 0 0 1 3 0c1 2.4 2.9 4.2 5.2 5.2a1.7 1.7 0 0 1 0 3 9.7 9.7 0 0 0-5.1 5.2 1.7 1.7 0 0 1-3.1 0 9.7 9.7 0 0 0-5.2-5.1zM30.2 50.2a1.2 1.2 0 0 1 0-2.2c1.7-.7 3-2 3.7-3.6a1.2 1.2 0 0 1 2.1 0c.7 1.6 2 3 3.7 3.6a1.2 1.2 0 0 1 0 2.2c-1.7.7-3 2-3.7 3.6a1.2 1.2 0 0 1-2.1 0c-.7-1.6-2-3-3.7-3.6zM199.5 52a1.2 1.2 0 0 1 0-2.2c1.7-.7 3-2 3.7-3.7a1.2 1.2 0 0 1 2.2 0c.7 1.7 2 3 3.6 3.7a1.2 1.2 0 0 1 0 2.1c-1.6.7-3 2-3.6 3.7a1.2 1.2 0 0 1-2.2 0c-.7-1.7-2-3-3.7-3.7zM175 146.4a1 1 0 0 1 0-1.7 5.4 5.4 0 0 0 2.8-2.9 1 1 0 0 1 1.8 0 5.4 5.4 0 0 0 2.8 2.9 1 1 0 0 1 0 1.7 5.4 5.4 0 0 0-2.8 2.9 1 1 0 0 1-1.8 0 5.4 5.4 0 0 0-2.9-3z"/></g><path d="M193.3 77.8c.3.2.3.6 0 .8l-37 16c-.7.4-1.6.6-2.6.6H96c-.8 0-1.7-.2-2.5-.5l-37-16.3c-.3 0-.3-.5 0-.7l20.6-18 2.8-1.8 19 11.2c.8.4 1.7.5 2.5.5h45.7a6 6 0 0 0 2.4-.5L171.1 59l.6.1 21.6 18.8z" fill="#96D327"/><path fill="#96D327" fill-rule="nonzero" d="M124.4 158.4l-67-76.2 36 13H157L191.1 82z"/><path d="M150.2 48.3H99L81.4 58.8s18.6 12.7 43 12.7c24.3 0 43.9-5.9 43.9-12.9 0-2-18.1-10.3-18.1-10.3z" fill="#A4EB21" fill-rule="nonzero"/><path d="M124.6 153.5L93.2 96.2c-.1-.2 0-.4.2-.4h63.7c.3 0 .4.2.3.4l-32.5 57.4c0 .2-.2.2-.3 0z" fill="#A4EB21"/><path d="M151.6 46.7c-.6-.4-1.3-.5-2-.5H99.5c-.7 0-1.4.1-2 .5l-17 8.6-24.2 17.3-.4.5a8.9 8.9 0 0 0 .3 11.3l65.6 74.4a3.5 3.5 0 0 0 5.3 0l65.6-74.5c2.6-3.1 3-7.6.6-10.9l-.7-.8-23-16-18-10zM83.7 58.4l15.8-8h50l15.9 8.2.6.3-.3.3-16 9c-2.8.2-17.7 1.3-25.4 1.3-7.9 0-21.9-1.7-23.4-2l-17.3-8.9.1-.2zm18 13.6c4.2.5 15.6 1.7 22.6 1.7 6.9 0 18.9-.7 24-1l6.4 20.9H95.8l5.9-21.6zm-42.4 4L80 61c.3.6 17.4 9.6 17.4 9.6l-6.2 22.9-32.7-16.2c.1-.4.3-1 .7-1.4zm2.5 7.8l28.3 14c.9.4 1.5 1 2 2l25.4 47.2-55.7-63.2zm62.6 66.9L96 98h58.6l-30.2 52.7zm7.3-3.9l26.9-47c.4-.9 1-1.5 2-2l26.1-13.4-55 62.4zm27.6-53.3l-6.8-22 17-9.8 20.4 14.2c.4.5.6 1 .6 1.6l-31.2 16z" fill="#212330" fill-rule="nonzero"/></g></svg>' } />
								<h2>{ __( 'Pro version is comming' ) }</h2>
								<h3>30% off coupon for every email subscriber</h3>
								<form action="https://updateby.email/sendy/subscribe" method="POST" accept-charset="utf-8" target="_blank">
									{/* <label for="name">Name</label><br/> */}
									<input type="text" name="name" id="name" placeholder="Name"/>
									<br/>
									{/* <label for="email">Email</label><br/> */}
									<input type="email" name="email" id="email" placeholder="Email"/><br/><br/>
								<input type="checkbox" name="gdpr" id="gdpr"/>
								<span className="gpdr-notice"><strong>Marketing permission</strong>: I'm ok to be in touch via email for the purpose of news on plugins development, security or important updates, and marketing proposals like special sale events.</span>
								<br/><br/>
									<input type="hidden" name="list" value="PrijsAb763HzofImg892L4RKfg"/>
									<input type="hidden" name="subform" value="yes"/>
									<input type="submit" name="submit" id="submit" className="button button-primary button-large"/>
								</form>
							</div>
						</div>
					}
					{ this.props.sidebarTab === 'promo' &&
						<div className={classnames( 'stylist-sidebar--promo', { active: this.props.sidebarTab === 'promo' } )} id="stylist-sidebar--promo">
							<div>
								{/* https://www.npmjs.com/package/react-svg-inline */}
								<a href="https://wpdesignhub.com/?utm_source=stylist&utm_medium=sidebar&utm_campaign=promo" target="_blank">
									<SVGInline svg={ '<svg width="246" height="243"  viewBox="0 0 246 243" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><linearGradient x1="0%" y1="100%" x2="93.3%" y2="5.6%" id="b"><stop stop-color="#FFD200" offset="0%"/><stop stop-color="#009FD2" offset="71%"/><stop stop-color="#025DF3" offset="100%"/></linearGradient><path d="M14.4 41.7l211-39a17 17 0 0 1 20.1 16.7V113a17 17 0 0 1-14 16.7l-211 39a17 17 0 0 1-20-16.7V58.4a17 17 0 0 1 14-16.7z" id="a"/><linearGradient x1="88.2%" y1="56.6%" x2="10.5%" y2="80.6%" id="c"><stop stop-color="#7185F6" offset="0%"/><stop stop-color="#FFD800" offset="100%"/></linearGradient><linearGradient x1="15.5%" y1="77.3%" x2="84%" y2="-9%" id="e"><stop stop-color="#F9FE11" offset="0%"/><stop stop-color="#00C2FF" offset="100%"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><g transform="translate(0 -2)"><mask id="d" fill="#fff"><use xlink:href="#a"/></mask><use fill="url(#b)" xlink:href="#a"/><path d="M-43.3-24.2c25.2-41 68.2-23 103.6 0 35.4 23 92.2 29.5 145.4.4C259-53 295.1 13.7 281.3 50.4c-13.8 36.7-54 69.2-174.2 69.2-120.3 0-175.6-102.7-150.4-143.8z" fill="url(#c)" opacity=".2" mask="url(#d)"/><path d="M274.8 139.4c-18.6 61.5-93.4 34.6-125.9 20-32.5-14.7-33.9 21.7-90.8 41.5-57 19.8-131-6.2-101-41.5C-12.8 124 45 82 126 59.9c81-22.2 167.5 17.9 148.9 79.5z" fill="url(#e)" opacity=".2" mask="url(#d)"/></g><g fill="#FFF" opacity=".7"><path d="M81 26a1.7 1.7 0 0 1 0-3.1c2.3-1 4.2-2.9 5.2-5.2a1.7 1.7 0 0 1 3 0c1 2.3 2.9 4.2 5.2 5.2a1.7 1.7 0 0 1 0 3 9.7 9.7 0 0 0-5.1 5.2 1.7 1.7 0 0 1-3.1 0 9.7 9.7 0 0 0-5.2-5.2zM207.1 111a1.7 1.7 0 0 1 0-3.1c2.3-1 4.2-2.8 5.2-5.2a1.7 1.7 0 0 1 3 0c1 2.4 2.9 4.2 5.2 5.2a1.7 1.7 0 0 1 0 3 9.7 9.7 0 0 0-5.1 5.2 1.7 1.7 0 0 1-3.1 0 9.7 9.7 0 0 0-5.2-5.1zM30.2 50.2a1.2 1.2 0 0 1 0-2.2c1.7-.7 3-2 3.7-3.6a1.2 1.2 0 0 1 2.1 0c.7 1.6 2 3 3.7 3.6a1.2 1.2 0 0 1 0 2.2c-1.7.7-3 2-3.7 3.6a1.2 1.2 0 0 1-2.1 0c-.7-1.6-2-3-3.7-3.6zM199.5 52a1.2 1.2 0 0 1 0-2.2c1.7-.7 3-2 3.7-3.7a1.2 1.2 0 0 1 2.2 0c.7 1.7 2 3 3.6 3.7a1.2 1.2 0 0 1 0 2.1c-1.6.7-3 2-3.6 3.7a1.2 1.2 0 0 1-2.2 0c-.7-1.7-2-3-3.7-3.7zM175 146.4a1 1 0 0 1 0-1.7 5.4 5.4 0 0 0 2.8-2.9 1 1 0 0 1 1.8 0 5.4 5.4 0 0 0 2.8 2.9 1 1 0 0 1 0 1.7 5.4 5.4 0 0 0-2.8 2.9 1 1 0 0 1-1.8 0 5.4 5.4 0 0 0-2.9-3z"/></g><path d="M74 177.2h5.9c3 0 5.8 1.2 8.1 3.4a11 11 0 0 1 3.6 8.3c0 3.2-1.2 6-3.5 8.4-2.3 2.3-5 3.5-8.3 3.5h-6c-1.2 0-2-.3-2.4-.8-.2-.5-.3-1.2-.3-2v-18-1l.3-.9c.3-.6 1.1-.9 2.5-.9zm5.9 17.9a6 6 0 0 0 4.1-1.7A5.6 5.6 0 0 0 86 189c0-1.8-.6-3.2-1.8-4.4a6 6 0 0 0-4.3-1.7h-3v12h3zm19.4 0h11l.9.4c.6.3.8 1.1.8 2.5 0 1.5-.4 2.3-1.1 2.6l-1.7.2H96.5c-1.5 0-2.4-.4-2.7-1.2a5 5 0 0 1-.1-1.7v-17.8c0-1 .2-1.8.6-2.2.4-.4 1.1-.6 2.3-.6h13.7l.9.3c.6.3.8 1.2.8 2.5 0 1.5-.4 2.4-1.1 2.7l-1.7.2h-9.9v3.2h7.4l1 .3c.5.3.8 1.2.8 2.6 0 1.5-.4 2.3-1.2 2.6l-1.7.2h-6.3v3.2zm15.2 2.4c-.6-.7-.9-1.3-.9-1.9 0-.5.5-1.2 1.4-2.1.6-.5 1.1-.8 1.7-.8.6 0 1.5.5 2.5 1.6.3.4.8.7 1.3 1 .6.4 1 .6 1.6.6 2 0 3-.9 3-2.5 0-.5-.3-.9-.9-1.2a6 6 0 0 0-2-.7 17.5 17.5 0 0 1-5.3-2 5.3 5.3 0 0 1-2-2 7 7 0 0 1-.8-3.6c0-1.9.7-3.5 2-5a7.7 7.7 0 0 1 5.8-2c1.3 0 2.4.2 3.5.5 1 .3 1.8.7 2.2 1l.8.6c.7.6 1 1.2 1 1.6 0 .4-.3 1-.8 1.7-.7 1.1-1.4 1.7-2.2 1.7a3.3 3.3 0 0 1-2-1l-.6-.4c-.4-.3-1-.4-1.7-.4s-1.2.1-1.7.5c-.5.3-.7.7-.7 1.3 0 .6.3 1.1.8 1.5a5 5 0 0 0 2 .7 24 24 0 0 1 5.4 1.6c.8.4 1.5 1 2 2a7 7 0 0 1 .8 3.5c0 1.4-.2 2.6-.8 3.7-.5 1-1.3 1.8-2.2 2.4a10 10 0 0 1-8.4 1.3c-.9-.2-1.6-.5-2.2-.9-1-.6-1.9-1.3-2.3-2l-.3-.3zm18.3-17.4V179l.4-.9c.3-.5 1.1-.8 2.5-.8 1.5 0 2.4.4 2.7 1.2l.1 1.6v19l-.3.8c-.3.6-1.2.9-2.5.9-1.5 0-2.4-.4-2.7-1.2a5 5 0 0 1-.2-1.7v-17.8zm20.5 6.5h5.7c1.1 0 1.8.4 2.1 1 .2.3.3 1 .3 1.7v7c0 .8-.3 1.4-.9 2-1.8 1.9-4.5 2.8-8 2.8-3.2 0-6-1.2-8.4-3.6a12 12 0 0 1-3.5-8.7c0-3.4 1.2-6.2 3.6-8.5a11.9 11.9 0 0 1 15.6-1c.6.5.9 1 .9 1.5s-.3 1.1-.8 1.8c-.8 1.1-1.5 1.7-2.2 1.7-.4 0-1-.3-2-.9a6.3 6.3 0 0 0-7.5.8 5.8 5.8 0 0 0-2 4.5c0 1.9.7 3.5 2 4.8a6 6 0 0 0 4.4 2c1.1 0 2.2-.3 3.1-.7v-3.5h-2.5c-.7 0-1.1 0-1.4-.2-.3-.2-.5-.4-.5-.8l-.2-1.3c0-.6 0-1 .2-1.4 0-.3.2-.6.5-.7.4-.2.9-.3 1.5-.3zm25.9-8.3c.2-.4.5-.7.9-.8l1.5-.2c.6 0 1.1 0 1.5.2.4 0 .7.2.8.4.2.1.4.3.4.6.2.4.2 1 .2 1.7V199l-.3.8c-.3.6-1.2.9-2.5.9-.9 0-1.4 0-1.8-.2l-.8-.6-9.5-12.6v11.7l-.3.8c-.3.6-1.1.9-2.5.9-1.3 0-2.2-.3-2.5-.9l-.3-.8V180c0-.8 0-1.4.3-1.7.2-.4.5-.7 1-.8l1.5-.2c.6 0 1.1 0 1.5.2l.8.4.7.8 9 12.2V180c0-.8.2-1.4.4-1.7z" fill="#2D2B29"/><path d="M111.8 70.7c-5.4 5-11.4 6.1-14.8 6.4h-2.8S92.5 51.9 107 37.4c3.8-3.8 7.5-6 11.1-6.9 10.1-2.7 18.4 4 19.7 9.3 1.8 7.3-1.4 11.8-26 30.9" fill="#DEE5D2"/><path d="M123.7 32.3c-1.7 0-3.4 0-5.1.6a23 23 0 0 0-10.1 6.2C97.2 50.4 96.3 68.8 96.3 75h.5a22.7 22.7 0 0 0 13.6-6c24.7-19.1 26.4-22.8 25.1-28.4-.8-3.1-5.3-7.7-11.8-8.2zM94.2 79.4h-.4c-1-.1-1.9-1-2-2.1 0-1-1.5-26.4 13.5-41.4 3.8-3.8 7.9-6.3 12.1-7.4 2.2-.6 4.4-.8 6.6-.7 8.3.6 14.6 6.4 15.8 11.6 2.1 8.8-2.1 14-26.6 33.1a27.2 27.2 0 0 1-19 7z" fill="#363F22"/><path d="M109.3 52.4c-10.5 9.7-11.7 20.4-11.7 20.4L97 77h-2.8S92.5 51.9 107 37.4a25 25 0 0 1 11-6.8c6.4 3.7.3 13.6-8.7 21.8" fill="#F9CF84"/><path d="M117.7 33c-3.1 1-6.2 3-9.2 6-8 8-10.8 19.8-11.8 28.1A41.1 41.1 0 0 1 108 50.7c6.7-6.1 11-12.6 10.6-16 0-.7-.3-1.2-.8-1.7zM94.3 79.4h-.4c-1.1-.2-2-1-2-2.1 0-1-1.6-26.5 13.5-41.5 3.8-3.8 7.9-6.3 12.1-7.5.6-.1 1.2 0 1.7.2a7.2 7.2 0 0 1 3.7 5.6c.8 7.3-8.1 16.4-12 20a33.7 33.7 0 0 0-11.7 23.4c-.2 1-1 1.8-2 1.9h-3z" fill="#363F22"/><path d="M171.6 71.5c-1.4 2.6-4.3 5-8.2 7.2-7.8 4.3-19.4 7.8-31.3 10.7 4.1 6.5 7 24.3-5.4 33.3-16.7 7.7-44.5-4.8-44.5-4.8s-10.3-6.2-7.9-21.3c2.4-15 20.7-25.8 32.7-23-4.6-2.7-4-5.6-1.2-6.8 2.8-1.2 9.9 2.3 11.4 5-.8-3.2 1.7-5.7 5.4-3.7s4.1 10 4.1 10 13.5-25.8 31.8-28.1c18.2-2.4 17.6 13.6 13.1 21.5" fill="#FFFFFE"/><path d="M105.4 71c2.5-1 8.5 1.3 9.8 3.8 6.3.1 2.4-5.5 5.7-3.7 3.2 1.8 2.2 10 2.2 10 .8-.2 3.2 0 3.8-1.1 1.3-2.5 3.3-7.2 6.3-11.8A81 81 0 0 0 127 78s-.5-8-4.2-10-6.2.5-5.4 3.7c-1.5-2.8-8.6-6.3-11.4-5-2.1.8-3 2.6-1.5 4.6.4 0 .7-.2 1-.3M122 119.6c-14.8 6.8-38.4-1.7-38.4-1.7l-1.3-.1s27.9 12.4 44.6 4.8c12.3-9 9.5-26.9 5.3-33.4 12-3 5-1.6-5.6 1 3.7 5.7 6.2 21.4-4.7 29.4z" fill="#DEE5D2"/><path d="M110.3 105.1c-4-.3-10.7-1.3-14.1-5-.5.7-1.1 1.4-1.9 1.8-3.3 2.2-8 1-8.1.9-.7-.2-1.2-1-1-1.7.2-.7 1-1.1 1.7-1 0 0 3.7 1 6-.5.9-.5 1.4-1.4 1.7-2.7 0-.6.5-1 1.1-1 .6-.2 1.2.2 1.4.7 2 4.5 10 5.6 13.4 5.8.7 0 1.3.7 1.2 1.5 0 .7-.7 1.3-1.4 1.2" fill="#363F22"/><path d="M83.2 116.5c3.2 1.9 14.3 5.3 27 6.2 6.2.4 11.4-.3 15.4-2 11.4-8.6 8-25 4.6-30.2a2.3 2.3 0 0 1 1.4-3.4c14.5-3.6 24.3-6.9 30.8-10.5 3.7-2 6.2-4.2 7.3-6.3 2.3-4 3.4-10 1.2-14-1.3-2.6-3.9-4-7.6-4.3-1.4-.1-2.9 0-4.5.1-17 2.2-30 26.7-30.1 27a2.2 2.2 0 0 1-4.2-1c-.2-2.7-1.2-7.1-3-8-.9-.6-1.7-.7-2-.3-.2.2-.3.7-.1 1.3.3 1.1-.3 2.3-1.4 2.7-1 .4-2.2 0-2.8-1-.8-1.5-5-3.9-7.7-4a2 2 0 0 0-.9 0c-.6.2-.8.5-.8.6 0 .1.3 1 2.3 2.2 1 .5 1.3 1.7 1 2.8-.5 1-1.6 1.6-2.7 1.3a15 15 0 0 0-2.3-.3c-10.8-.8-25.6 8.6-27.6 21.4-2 12.7 3.4 17.7 6.7 19.7zm-1.4 4.3c-2.8-1.6-12.3-8.3-9.7-24.7 2.2-14.2 17-24.5 29.5-25.3l-.3-1.7c.2-2 1.5-3.6 3.6-4.5.8-.4 1.8-.5 2.9-.4 2.3.2 5.5 1.4 8 3a5.2 5.2 0 0 1 4.7-2.2c1 .1 2.1.4 3.2 1 2 1.2 3.3 3.5 4.1 5.8 5.1-8 16.3-22.3 30.4-24.2 2-.2 3.7-.3 5.4-.2 6.7.5 9.8 4 11.3 6.7 3 5.8 1.5 13.6-1.3 18.5a22.6 22.6 0 0 1-9 8c-6.5 3.5-15.8 6.8-29.2 10.2 1.8 4 2.7 9.3 2.4 14.3a24.7 24.7 0 0 1-10.1 19.6 36.8 36.8 0 0 1-17.9 2.5 81.4 81.4 0 0 1-28-6.4z" fill="#363F22"/><path d="M109 99.6c-.2 0-.5-.1-.7-.4-10.1-9-21.4-3.6-21.9-3.4-.7.3-1.5 0-1.8-.6-.3-.7 0-1.5.6-1.8.2-.1 13.4-6.4 24.9 3.8a1.4 1.4 0 0 1-1 2.4" fill="#363F22"/><path d="M91 91.2c-.6 0-1-.3-1.2-.8-.6-1.3-1.3-2-2.1-2-1.2-.2-2.6 1-3 1.4a1.4 1.4 0 1 1-2-1.8c.2-.3 2.6-2.7 5.4-2.4 1.7.3 3 1.5 4.1 3.6a1.4 1.4 0 0 1-1.3 2M116.5 96.3c-.5 0-.9-.3-1.1-.7-.8-1.6-1.9-2.6-3.2-3-2.3-.6-4.8 1.2-4.8 1.2a1.3 1.3 0 0 1-1.6-2.2c.2-.1 3.5-2.5 7-1.6 2.2.5 3.8 2 5 4.4a1.4 1.4 0 0 1-1.3 2" fill="#363F22"/><path d="M93 92.7s1.6 3 2.9 4.5c2-1 4.8-3.8 4.8-3.8s-3.5-2.8-7.7-.7" fill="#E47272"/><path d="M94.8 93.3l1.3 2a22 22 0 0 0 2.3-1.7c-.5-.2-1.2-.4-1.9-.4l-1.7.1zm.9 5.2c-.4 0-.7-.2-1-.5-1.3-1.7-3-4.6-3-4.7a1.4 1.4 0 0 1 .6-1.9c1.4-.7 2.9-1 4.4-1 2.8.3 4.7 1.8 4.8 1.9a1.4 1.4 0 0 1 .1 2c-.1.1-3 3-5.3 4-.2.2-.4.2-.6.2z" fill="#363F22"/><path d="M88.6 101.9s2.2 15.5 10 16c7.7.5 10.5-9.1 11-14.1-4.2-.3-10.5-1.4-13.9-6.5-.8 4.2-4.1 5-7 4.6" fill="#C54E4D"/><path d="M108.3 105.3a19.7 19.7 0 0 0-16.2 7.4c1.6 2.9 3.7 5.3 6.7 5.5 7.1.4 10.1-7.6 10.9-12.9h-1.4" fill="#E98B93"/><path d="M90.3 103.4c1 4.7 3.6 13 8.4 13.3 6.1.3 8.7-6.8 9.5-11.6-5.3-.6-9.2-2.2-12-5-1 2-3.2 3.2-5.9 3.3zm8.2 16c-8.7-.6-11-16.6-11.1-17.2 0-.4 0-.9.4-1.2.2-.3.7-.4 1-.4h.6c4.4.4 5-2.6 5.1-3.5.1-.6.5-1 1-1 .6-.2 1.2 0 1.5.5 2.3 3.5 6.4 5.5 12.7 6 .4 0 .7.1 1 .4.2.3.3.6.3 1-.5 5.5-3.7 16-12.4 15.4h-.1z" fill="#363F22"/><path d="M163.5 78.7c-7.8 4.3-19.4 7.8-31.3 10.7 0 0 10.5-15.8 16.3-22.3 5.9-6.6 14-9.2 18.6-2.4 2.7 4 .6 9.2-3.6 14" fill="#F9CF84"/><path d="M160.5 63c-3.1-.3-7 1.8-10.3 5.5-3.7 4.2-9.3 12.1-12.9 17.3a114 114 0 0 0 24.8-9c2.3-2.6 5.5-7.3 3.2-10.8-1.3-2-2.9-3-4.8-3zM132 91.6c-.6 0-1.3-.4-1.6-1-.6-.7-.6-1.7 0-2.5.4-.7 10.7-16 16.6-22.7 4.3-4.8 9.4-7.4 14-7.1 3.2.2 6 2 8.1 5 3 4.6 1.7 10.6-3.8 16.8l-.6.5a133.3 133.3 0 0 1-32.7 11z" fill="#363F22"/><path d="M177.1 105.9a10 10 0 0 1 2.4 16.3 11.6 11.6 0 0 1-11.3 17.8 11.6 11.6 0 1 1-5.4-20.3l-.5-.1c-7-1.1-11.8-7.7-10.6-14.8 1-7.1 7.7-12 14.7-10.8 6 1 10.3 6 10.7 11.9z" fill="#6CBD45"/><path d="M146.4 125.1a159.7 159.7 0 0 0 14-1.8 7.8 7.8 0 0 0 6.3 9c4.2.7 8.2-2.2 8.9-6.6a8 8 0 0 0-1.1-5.4c2.3-1.4 4-3.7 4.5-6.6.5-3.5-.8-6.7-3.3-8.7-.3-4.4-2.7-8.2-6.4-10.2 4.3 1.5 7.2 5.9 7.5 11a9.8 9.8 0 0 1 4.5 10.2c-.4 2.2-1.4 4.2-2.7 5.6 1.3 2.3 1.8 5 1.4 8-1 6.1-6.2 10.4-11.6 9.6-5.2-.9-8.8-6.2-8.1-12.1a190 190 0 0 1-13 2l-1-4z" fill="#28A848"/><path d="M177.1 105.9a10 10 0 0 1 2.4 16.3 11.6 11.6 0 0 1-11.3 17.8 11.6 11.6 0 1 1-5.4-20.3l-.5-.1c-7-1.1-11.8-7.7-10.6-14.8 1-7.1 7.7-12 14.7-10.8 6 1 10.3 6 10.7 11.9z" stroke="#363F22" stroke-width="4.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M141 118.6c14-3.9 21.4-8 22.1-12.2 1-6.4 8.5 15 6.1 17.8-1.6 1.9-10 3.6-25.3 5.1l-3-10.7z" fill="#6CBD45"/><path d="M146.7 117.2a24.7 24.7 0 0 0 14.8-9.3M145 128.5c9.2-.5 15.8-1.4 19.6-2.7" stroke="#363F22" stroke-width="4.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M66.2 171.6c-17.7-2.8 41.2-60.3 56.1-64.9 15-4.6 36.4 20 25.6 32.3-4.8 5.5-18.6 9.6-33.1 16-18.5 8.2-38.8 18.2-48.6 16.6z" fill="#FFB700"/><path d="M149 123.8c2.3 5.4 2.3 11.1-1.4 15.3-4.8 5.5-18.5 9.5-33 16-17.8 7.9-37.1 17.4-47.4 16.8 26.3-27.5 53.6-43.5 81.8-48z" fill="#FD6B0B"/><path d="M66 169.5c3.6.5 9.1-.6 16.8-3.3 6-2.1 11.7-4.5 23.4-9.7l1.8-.9a1235.9 1235.9 0 0 1 14-6l8.4-3.4 7.1-3c4.7-2.1 7.6-4 9.2-5.7 2.2-2.4 3-5.5 2.3-9-.7-3.5-2.6-7.2-5.4-10.6-5.9-7-14.2-10.8-20.4-9-6.8 2.1-25 17-39.9 32.5-7.6 8-13.5 15.2-16.5 20.6a14 14 0 0 0-2.3 6.1c0 .9.3 1.2 1.5 1.4zm-5.7-1.3c0-2.2 1-5 2.9-8.3 3.2-5.7 9.3-13.2 17.1-21.4 15.4-16 34-31.1 41.7-33.5 8-2.5 18 2 24.8 10.2 3.3 4 5.5 8.3 6.3 12.5.8 4.7-.2 9.1-3.3 12.6-2 2.3-5.4 4.3-10.6 6.7-2 .9-4.3 1.9-7.3 3l-8.3 3.4a285.4 285.4 0 0 0-13.9 6l-1.9.8a313.7 313.7 0 0 1-23.7 10 42 42 0 0 1-18.8 3.4c-3-.5-5-2.4-5-5.4z" fill="#363F22" fill-rule="nonzero"/><path d="M75.9 149c3.6.6 4 1.5 6.3 5.1M106.8 158c1.2-3.1-.8-6-2.7-8.4M113 112.4c3.4 1.4 4 1.8 5.5 5.2" stroke="#363F22" stroke-width="4.9" stroke-linecap="round" stroke-linejoin="round"/><g><path d="M88.1 133.7s-4.4-2.6-4.6-7.5c-.3-5 15.8-5.8 15.4 0-.4 6-6.3 10.5-10.8 7.5" fill="#FFFFFE"/><path d="M85.7 126c.2 3.7 3.5 5.7 3.6 5.8 1.5 1 3.4.7 5-.7 1.3-1.2 2.2-3 2.4-5 0-.7-1.8-1.5-4-1.7-3.8-.2-6.7 1-7 1.7zm5 11c-1.4-.2-2.6-.6-3.8-1.4-.6-.4-5.4-3.5-5.7-9.3 0-1.3.5-2.6 1.5-3.6 2.3-2.3 6.8-3 10.2-2.8 5.3.4 8.5 2.9 8.2 6.5-.2 3.1-1.6 6-3.9 8.1a9 9 0 0 1-6.5 2.4z" fill="#363F22"/></g><g><path d="M130.2 145.5s-.6-4.8 1.4-6c2-1 10 3 11.3 7 1.2 4-7.2 7.4-9 6.8-1.6-.7-3-4.4-3.7-7.8" fill="#FFFFFE"/><path d="M132.4 145.2c.6 3.1 1.8 5.3 2.3 5.9 1.2-.1 4.4-1.4 5.8-3.1.2-.4.4-.7.3-.9-.7-2.3-5.8-5.3-8.1-5.4-.3.6-.4 2.2-.3 3.5zm1.8 10.4c-.3 0-.7 0-1-.2-3.6-1.5-5-8.1-5.2-9.4v-.1c-.2-1.5-.6-6.6 2.6-8.3.6-.4 1.4-.5 2.4-.4 3.8.2 10.7 4 12 8.5.6 1.7.2 3.5-1 5.1-2.2 2.8-7.2 5-9.8 4.8z" fill="#363F22"/></g><g><path d="M79.6 221c.3 0 .5 0 .7.3.2.2.3.4.3.7 0 .3 0 .5-.3.7a1 1 0 0 1-.7.3H72c-.4 0-.7-.2-1-.4-.2-.3-.3-.6-.3-1v-12.9c0-.3 0-.5.2-.7.2-.2.5-.3.7-.3.3 0 .5.1.7.3.2.2.3.4.3.7V221h7.1zm4.4-13.3c.3 0 .5.1.7.3.2.2.3.4.3.7v13.4c0 .3 0 .5-.3.7a1 1 0 0 1-.7.3 1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7v-13.4c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3zm14 7.4c1 .3 1.6.7 2.2 1.3.5.6.8 1.4.8 2.3 0 1.3-.4 2.4-1.3 3.1-1 .8-2.3 1.2-4.3 1.2h-5.2a1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7v-13.2c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h5.1c1.6 0 2.8.4 3.6 1 .8.8 1.3 1.7 1.3 3 0 .8-.2 1.5-.6 2-.4.6-1 1-1.6 1.3zm.3-3.2a2 2 0 0 0-.9-1.6c-.5-.4-1.3-.6-2.2-.6h-4v4.7h3.6c1.3 0 2.2-.2 2.7-.7.5-.4.8-1 .8-1.8zm-3 9.2c1.3 0 2.3-.2 3-.6.5-.5.8-1 .8-1.9 0-1.6-1.3-2.5-3.8-2.5h-4.1v5h4zm20.7 1c0 .3 0 .5-.2.7a1 1 0 0 1-.7.3 1 1 0 0 1-.8-.3 1 1 0 0 1-.2-.7v-.7l-.2-2c-.2-.6-.5-1.1-1-1.6s-1.2-.7-2.2-.7h-4.5v5c0 .3 0 .5-.3.7a1 1 0 0 1-.7.3 1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7v-13.3c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h5c2 0 3.5.4 4.5 1.2a4 4 0 0 1 1.5 3.2c0 .9-.3 1.7-.8 2.4a4 4 0 0 1-2 1.5 3 3 0 0 1 2 2c.4 1 .6 2 .6 3v1zm-5.9-7c1.3 0 2.3-.2 3-.6.7-.5 1-1.2 1-2.1 0-.9-.2-1.6-.8-2-.7-.5-1.8-.7-3.3-.7h-3.8v5.5h4zm22 6.6v.4c0 .3 0 .5-.2.7a1 1 0 0 1-.7.3 1 1 0 0 1-.6-.2 1 1 0 0 1-.4-.4l-1.4-3.4h-7.3l-1.5 3.4-.3.4a1 1 0 0 1-.6.2 1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7l.1-.4 5.6-13.1c0-.3.3-.5.5-.6.2-.2.4-.3.7-.3h.2c.4 0 .6.1.8.3.2.1.4.3.5.6l5.5 13zm-7-11.5l-2.9 7h5.9l-3-7zm21.5 11.9c0 .3-.1.5-.3.7a1 1 0 0 1-.7.3 1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7v-.7c0-.7 0-1.4-.2-2-.1-.6-.4-1.1-1-1.6-.4-.5-1.2-.7-2.2-.7h-4.4v5c0 .3-.1.5-.3.7a1 1 0 0 1-.7.3 1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7v-13.3c0-.3 0-.5.3-.7.2-.2.4-.3.7-.3h5c2 0 3.5.4 4.4 1.2a4 4 0 0 1 1.5 3.2c0 .9-.2 1.7-.7 2.4a4 4 0 0 1-2.1 1.5 3 3 0 0 1 2.1 2c.4 1 .6 2 .6 3v1zm-6-7c1.3 0 2.3-.2 3-.6.8-.5 1.1-1.2 1.1-2.1 0-.9-.3-1.6-.9-2-.6-.5-1.7-.7-3.2-.7h-3.8v5.5h3.9zm19-6.9a1 1 0 0 1 1.6-.2c.2.2.3.4.3.7 0 .2 0 .4-.2.6l-5.2 7.3v5.5c0 .3-.1.5-.3.7a1 1 0 0 1-.7.3 1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7v-5.5l-5.2-7.3-.1-.6c0-.3 0-.5.2-.7.2-.2.4-.3.7-.3.4 0 .7.2.9.5l4.5 6.6 4.6-6.6z" fill="#363F22"/><path d="M72 233.8c-.3 0-.6.1-.7.3-.2.1-.3.4-.3.8v.7h1.6c.1 0 .2 0 .3.2l.2.3a.5.5 0 0 1-.5.5H71v5s0 .2-.2.3l-.4.2c-.1 0-.3 0-.4-.2a.5.5 0 0 1-.1-.4v-4.9H69l-.3-.1a.5.5 0 0 1-.2-.4c0-.1 0-.3.2-.3l.3-.2h.8v-.7c0-.5 0-1 .2-1.2.2-.4.5-.6.7-.7a2 2 0 0 1 1-.3c.3 0 .7.1 1 .3.1 0 .2 0 .3.2v.2l-.1.4-.3.1h-.3a6 6 0 0 0-.4 0zm4.9 1.7c.6 0 1.2.1 1.7.4.4.3.8.7 1 1.2.4.5.5 1 .5 1.7s-.1 1.3-.4 1.8c-.3.5-.7.9-1.1 1.1-.5.3-1 .4-1.7.4s-1.2 0-1.7-.4c-.5-.2-.9-.6-1.1-1.1-.3-.5-.4-1.1-.4-1.8 0-.6 0-1.2.4-1.7.2-.5.6-1 1-1.2.6-.3 1.1-.4 1.8-.4zm0 5.6c.3 0 .6 0 1-.2.3-.2.5-.4.7-.8.2-.3.3-.8.3-1.3s0-1-.3-1.3c-.2-.3-.4-.6-.7-.7a2.2 2.2 0 0 0-2 0c-.3.1-.6.4-.8.7-.2.4-.3.8-.3 1.3s.1 1 .3 1.3c.2.4.5.6.8.8l1 .2zm8-5.6l.4.2.1.4c0 .1 0 .2-.2.3l-.4.2c-.4 0-.8 0-1.1.3-.4.2-.7.5-.9.8v3.8l-.1.4-.5.2-.4-.2a.5.5 0 0 1-.1-.4v-5.4l.1-.4.4-.1.5.1.1.4v.6c.6-.8 1.3-1.2 2-1.2zm10.2-2.3a.7.7 0 0 1 .7.5l2.1 6.9 2.1-7 .2-.3.4-.1c.1 0 .3 0 .4.2l.1.3v.3l-2.5 7.5c0 .2-.1.3-.3.4l-.4.2c-.2 0-.3 0-.5-.2a.8.8 0 0 1-.2-.4l-2-6.4-2 6.4a.8.8 0 0 1-.8.6c-.2 0-.3 0-.5-.2a.9.9 0 0 1-.3-.4l-2.4-7.5v-.3-.3c.2-.2.3-.2.5-.2l.3.1.3.3 2 7 2.2-7 .2-.3.4-.1zm10.2 2.3c.6 0 1.2.1 1.6.4.5.3 1 .7 1.2 1.2.2.5.4 1 .4 1.7s-.2 1.3-.4 1.8c-.3.5-.7.9-1.2 1.1-.4.3-1 .4-1.6.4-.7 0-1.2 0-1.7-.4-.5-.2-.9-.6-1.2-1.1-.2-.5-.3-1.1-.3-1.8 0-.6 0-1.2.3-1.7s.7-1 1.2-1.2c.5-.3 1-.4 1.7-.4zm0 5.6c.3 0 .6 0 1-.2.3-.2.5-.4.7-.8.2-.3.3-.8.3-1.3s0-1-.3-1.3c-.2-.3-.4-.6-.8-.7a2.2 2.2 0 0 0-2 0l-.7.7c-.2.4-.3.8-.3 1.3s0 1 .3 1.3c.2.4.5.6.8.8l1 .2zm8-5.6c.1 0 .2 0 .3.2l.2.4c0 .1 0 .2-.2.3l-.4.2c-.4 0-.8 0-1.1.3-.4.2-.7.5-.9.8v3.8c0 .2 0 .3-.2.4l-.4.2c-.1 0-.3 0-.4-.2a.5.5 0 0 1-.1-.4v-5.4l.1-.4.4-.1.4.1c.2.1.2.3.2.4v.6c.6-.8 1.3-1.2 2-1.2zm4.3 0c.8 0 1.5.3 2.1 1v-3.1c0-.2 0-.3.2-.4.1-.2.2-.2.4-.2s.3 0 .4.2l.2.4v8.1c0 .2 0 .3-.2.4l-.4.2c-.2 0-.3 0-.4-.2a.5.5 0 0 1-.2-.4v-.3a2.9 2.9 0 0 1-3.6.5 3 3 0 0 1-1.1-1.1c-.3-.5-.5-1.1-.5-1.8s.2-1.3.5-1.8a3 3 0 0 1 2.6-1.5zm.1 5.6c.4 0 .8-.1 1.1-.3l1-.7v-2.6l-1-.7c-.3-.2-.7-.2-1-.2a2 2 0 0 0-1.6.5c-.3.4-.5 1-.5 1.7s.2 1.3.5 1.7c.4.4 1 .6 1.5.6zm8.8-7.8c.8 0 1.4 0 2 .4.4.2.8.6 1 1 .2.4.4.9.4 1.3 0 .5-.2 1-.4 1.4-.2.4-.6.8-1 1-.6.3-1.2.4-2 .4h-2.3v2.7c0 .2 0 .3-.2.4l-.4.2c-.1 0-.3 0-.4-.2a.5.5 0 0 1-.1-.4v-7.7l.1-.4.4-.1h2.9zm-.1 4.5c.8 0 1.4-.2 1.8-.5.3-.4.5-.8.5-1.3 0-.4-.2-.8-.5-1.2-.4-.3-1-.5-1.8-.5h-2.2v3.5h2.2zm8-2.3s.2 0 .3.2l.2.4c0 .1 0 .2-.2.3l-.4.2c-.5 0-.8 0-1.2.3l-.8.8v3.8c0 .2 0 .3-.2.4l-.4.2c-.1 0-.3 0-.4-.2a.5.5 0 0 1-.2-.4v-5.4l.2-.4.4-.1.4.1.2.4v.6c.6-.8 1.2-1.2 2-1.2zm6.5 5.1c.1 0 .2 0 .3.2l.2.3c0 .2-.1.4-.3.5l-1 .4-1.2.1c-1 0-1.8-.2-2.4-.8-.6-.6-.9-1.4-.9-2.5 0-.6.1-1.1.4-1.6.2-.5.5-1 1-1.2.4-.4 1-.5 1.6-.5a2.8 2.8 0 0 1 2.6 1.6c.3.5.4 1 .4 1.6l-.1.4-.5.1h-4.2c0 .6.3 1 .6 1.4.4.3 1 .5 1.6.5a3.8 3.8 0 0 0 1.7-.4h.2zm-2.3-4.1a2 2 0 0 0-.8.2c-.3 0-.5.3-.7.6a2 2 0 0 0-.3 1h3.7a2 2 0 0 0-.3-1l-.7-.6a2 2 0 0 0-.9-.2zm5.3 1c0 .2.1.3.4.5l1 .3 1.3.4.8.5c.2.3.3.7.3 1 0 .6-.2 1-.6 1.4-.5.4-1 .5-1.8.5-.9 0-1.6-.1-2.3-.5a.5.5 0 0 1-.2-.4l.1-.4.4-.1h.2l.8.3h.9c1 0 1.4-.2 1.4-.8 0-.2-.1-.3-.3-.4l-1-.4-1.3-.3-.8-.6c-.3-.3-.4-.6-.4-1 0-.6.2-1 .7-1.5.4-.3 1-.5 1.8-.5l1.8.3.3.2v.6l-.5.2h-.1l-1.4-.3a2 2 0 0 0-1.1.3c-.3.1-.4.4-.4.6zm6 0c0 .2.2.3.4.5l1 .3 1.3.4.8.5c.2.3.3.7.3 1 0 .6-.2 1-.6 1.4-.4.4-1 .5-1.8.5s-1.6-.1-2.3-.5a.5.5 0 0 1-.2-.4l.1-.4.4-.1h.2l.8.3h1c.8 0 1.3-.2 1.3-.8 0-.2-.1-.3-.3-.4l-1-.4-1.3-.3-.8-.6c-.2-.3-.4-.6-.4-1 0-.6.3-1 .7-1.5.4-.3 1-.5 1.8-.5l1.8.3.3.2v.6l-.4.2h-.2l-1.4-.3a2 2 0 0 0-1 .3c-.3.1-.5.4-.5.6z" fill="#848580"/></g></g></svg>' } />
								</a>
								<h2>{ __( 'Design library for new WordPress block editor.' ) }</h2>
								<a href="https://wpdesignhub.com/?utm_source=stylist&utm_medium=sidebar&utm_campaign=promo" target="_blank" className="button button-large button-primary ">Free WP PLugin</a>
							</div>
						</div>
					}
				</div>
			</ResizeAndDragBox>
		)
	}
}

export default Sidebar;



// WEBPACK FOOTER //
// ./dev/stylist_parent/editor/sidebar/index.jsx